import { useMemo } from "react";

import MfaBeginEnrollOptionsInstance from "@auth0/auth0-acul-js/mfa-begin-enroll-options";
import type { MfaEnrollFactorType } from "@auth0/auth0-acul-js/mfa-begin-enroll-options";

import { executeSafely } from "../utils/helpers/executeSafely";

export const useMfaEnrollmentManager = () => {
  const mfaEnrollInstance = useMemo(
    () => new MfaBeginEnrollOptionsInstance(),
    []
  );

  const { screen, tenant } = mfaEnrollInstance;
  const { texts } = screen;

  const handleEnroll = async (factor: MfaEnrollFactorType): Promise<void> => {
    executeSafely(`MFA enroll with factor: ${factor}`, () =>
      mfaEnrollInstance.enroll({ action: factor })
    );
  };

  return {
    mfaEnrollInstance,
    handleEnroll,
    texts: (texts || {}) as Record<string, string>,
    errors: mfaEnrollInstance.getError(),
    enabledFactors: (tenant.enabledFactors || []) as MfaEnrollFactorType[],
  };
};
